import { Model } from 'vuex-orm';

import Profile from '../profile/model';
import Company from '../company/model';
import UserMembership from '../userMembership/model';
import Version from '../version/model';

export default class User extends Model {
  static entity = 'users';

  static fields() {
    return {
      id: this.attr(null),
      company_id: this.attr(null),
      uuid: this.attr(''),
      email: this.attr(''),
      status: this.attr(''),
      master: this.attr(''),
      admin: this.attr(''),
      locale: this.attr(''),
      timezone: this.attr(''),
      deactivated: this.attr(''),
      policy_accepted_at: this.attr(''),
      last_sign_in_at: this.attr(''),
      confirmed_at: this.attr(''),
      permissions: this.attr(null),
      employment_type: this.attr(null),
      joining_date: this.attr(null),
      remaining_pto_days: this.attr(null),
      remaining_sickness_days: this.attr(null),

      profile: this.hasOne(Profile, 'user_id'),
      company: this.belongsTo(Company, 'company_id'),
      user_memberships: this.hasMany(UserMembership, 'user_id'),
      versions: this.hasMany(Version, 'user_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/model.js